/* 为了兼容五人制，设置的一些常用变量 */
import { storageData } from "@/assets/js/storage";
import { checkIsFiveByUserType } from '@/assets/js/status';
import { teacherFilter, classInfoBoxLevelFilter, classTypeFilter, parseUnitName } from '@/assets/js/yioksFilters';
import { teacher_level, teacher_level_five,
          class_train_type_list, class_train_type_list_five,
          classLevelList,classLevelListForGoalkeeper,classLevelListForPhysical, classLevelListFive, tea_level,tea_level_five,
          colLevellist, colLevellistFive, teacher_level_goalkeeper } from '@/assets/js/select';

export default {
  computed: {
    // 登录用户本地信息
    loginUserInfoSaved() {
      return storageData.getUserInfo();
    },

    // true: 五人制； false：十一人制
    isFive() {
      const loginUserInfo = storageData.getUserInfo();
      if (loginUserInfo) {
        const { member_type } = loginUserInfo;
        const res = checkIsFiveByUserType(member_type)  // 通过用户的身份判别属于五人制还是十一人制
        if (res) {
          return res
        } else {
          console.warn('登录用户信息检索失败')
          return false
        }
      } else {
        console.warn('登录用户信息检索失败')
        return false
      }
    },

    // 讲师等级列表（五人制/十一人制）
    teacherLevelList() {
      if(this.isFive) {
        return teacher_level_five;
      } else {
        return teacher_level;
      }
    },

    // 培训班类型列表（五人制/十一人制）
    classTrainTypeList() {
      if(this.isFive) {
        return class_train_type_list_five;
      } else {
        return class_train_type_list;
      }
    },

    // 培训班等级列表
    classTrainLevelList() {
      if(this.isFive) {
        return classLevelListFive
      } else {
        // return classLevelList.concat(classLevelListForGoalkeeper)
        return classLevelList.concat(classLevelListForGoalkeeper).concat(classLevelListForPhysical);
      }
    },

    // 讲师select tea_level,tea_level_five,
    taecherLevelSelect() {
      if(this.isFive) {
        return tea_level_five
      } else {
        return tea_level
      }
    },

    teacherLevelGoalkeeper() {
      if(this.isFive) {
        return teacher_level_goalkeeper
      } else {
        return teacher_level_goalkeeper
      }
    },

    // 教练选择
    coachLevelSelect() {
      if(this.isFive) {
        return colLevellistFive
      } else {
        return colLevellist
      }
    },

  },

  filters: {
    teacherFilter,  // 讲师等级
    classInfoBoxLevelFilter,  // 培训班等级
    classTypeFilter,  // 培训班类型type
    parseUnitName,  // 解析unitName返回用户角色
  },

  mounted() {
    // console.log('mounted: isFive', this.isFive)
    // console.log('mounted: classTrainLevelList', this.classTrainLevelList)
    // console.log('mounted: filterData', this.filterData)
  },

  methods: {
    /* 十一人制 "C", "D", 五人制 "early" 显示； 否则隐藏 */
    ifClassLevelShow(classLevel) {
      if(classLevel) {
        return ['C', 'D', 'early','L1','L2','L3'].includes(classLevel)
      } else {
        return false
      }
    },

    /* 判断培训班非十一人制D级且非五人制Early初级 */
    notDEqual(classLevel) {
      if(classLevel) {
        if("D" !== classLevel && "early" !== classLevel) {
          return true
        } else {
          false
        }
      } else {
        return false
      }
    },

    /* 角色可见设置 */
    userAvaible(whiteList = [], member_type = '') {
      if(whiteList.length || !member_type) {
        return whiteList.includes(member_type)
      } else {
        // 无识别白名单默认false　或角色为空
        return false
      }
    },

    isStudentRole(userType) {
      if(userType) {
        const stu_list = ['student', 'stuFive', 'expireStudent', 'expFive'];
        return stu_list.includes(userType)
      } else {
        return false
      }
    },
  },
}
